import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import styles from "./BannerSlider.module.css";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
// import { slugify } from "../../../../base/utils";
import { LangLink } from "../../LangLink/LangLink";

const BannerSlider = ({ bannerGroup, isHeader = false }) => {
  const navigate = useLangNavigate();
  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    Autoplay({
      stopOnInteraction: false,
      delay: 8000,
    }),
    WheelGesturesPlugin(),
  ]);

  const renderMediaElement = (src, alt = "", props = {}) => {
    if (!src) return null;

    const extension = src.split(".").pop().toLowerCase();
    const isVideo = ["webm", "mp4", "ogg"].includes(extension);
    const isImage = ["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(
      extension
    );

    if (isVideo) {
      return (
        <video
          src={src}
          autoPlay
          loop
          muted
          playsInline
          {...props}
          style={{ height: "55px" }}
        />
      );
    }

    if (isImage) {
      return (
        <img
          src={src}
          alt={alt}
          {...props}
          style={{ borderRadius: isHeader && "0" }}
        />
      );
    }

    return <div>Unsupported media format</div>;
  };

  return (
    <div className={styles.Container} data-header={isHeader}>
      <div dir="ltr" ref={emblaRef}>
        <div className="embla__container">
          {bannerGroup.sections.map((b, i) => (
            <div className="embla__slide" key={i}>
              {!b.images[0]?.external_url && !b.images[0]?.internal_url ? (
                renderMediaElement(b.images[0].url, "banner", {
                  className: styles.SlideImage,
                  onClick: () => {
                    const product_id =
                      b.images?.[0]?.reference_product.values?.[0]?.reference;
                    // const name =
                    //   b.images?.[0]?.reference_product.values?.[0]?.name;
                    if (product_id) {
                      navigate(`/product/${product_id}`);
                    }
                  },
                  onLoadedMetadata: () => {
                    console.log("second");
                  },
                  onLoad: () => {
                    window.dispatchEvent(new Event("resize"));
                  },
                })
              ) : b.images[0]?.external_url ? (
                <a
                  href={b.images[0]?.external_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  {renderMediaElement(b.images[0].url, "banner", {
                    className: styles.SlideImage,
                  })}
                </a>
              ) : (
                <LangLink to={b.images[0]?.internal_url}>
                  {renderMediaElement(b.images[0].url, "banner", {
                    className: styles.SlideImage,
                  })}
                </LangLink>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BannerSlider;
